<template>
  <div class="introduce-container" id="introduce">
    <div id="introduce-pc">
      <Title :ch="'大会介绍'"></Title>
      <div class="content">
        <div class="text">
          <div class="con">
            <p>各位朋友:</p>
            <p>大家好！</p>
            <p>
              6月15日，<span class="color-red">“华为伙伴暨开发者大会2022”</span>
              将通过线上加线下的方式举行。在这次活动中，我们将围绕伙伴和开发者关心的一些热点话题，比如军团、商业市场、华为云以及计算产业的发展等等，与大家进行深入交流。我们还将推出新的产品和发布新的伙伴政策。
            </p>
            <p>您的参与和您的建议，是我们最大的期待。</p>
            <p>“因聚而生，为你所能”。</p>
            <p>6月15日，不见不散！</p>
            <!--            数字世界日新月异，直面数字化新蓝海，扬帆起航、乘风破浪，需要每一位合作伙伴与开发者的共同努力，以赢得先机。<br />-->
            <!--            <span class="color-red">首届“华为伙伴暨开发者大会”</span>，以<span-->
            <!--              class="title"-->
            <!--              >“因聚而生 为你所能”</span-->
            <!--            >为主题，采用线上直播+线下近90个分会场联动的形式，承接<span-->
            <!--              class="link_text cs"-->
            <!--              @click="didClick_link(0)"-->
            <!--              >“华为中国生态大会”</span-->
            <!--            >开放共赢的理念和<span-->
            <!--              class="link_text cs"-->
            <!--              @click="didClick_link(1)"-->
            <!--              >“HDC.Cloud”</span-->
            <!--            >勇于创新的精神，聚焦伙伴和开发者最为关切的话题，给出切实方案；聚合每一位ICT产业成员，能力互补，共同成就；释放更多潜力，拥抱更广阔的价值新空间，携手实现更大的商业成功。-->
          </div>
        </div>
        <div class="media flex align-center">
          <div class="bgImg"></div>
          <img
            v-show="!playState"
            class="pauseImg"
            :src="pauseImg"
            @click="didClick_pauseImg"
          />
        </div>
      </div>
    </div>
    <div id="introduce-wap">
      <Title :bg-img="titleBgImg"></Title>
      <div class="content-box">
        <div class="media flex flex-direction align-center">
          <div class="bgImg flex" style="overflow: hidden"></div>
          <img
            v-show="!playState && !$store.state.isXiaoMi"
            @click="didClick_pauseImg"
            class="pauseImg"
            src="../assets/images/introduce/pause-mobile.png"
          />
        </div>
        <div class="content">
          <div class="text flex flex-direction align-center">
            <div class="con">
              <p>各位朋友:</p>
              <p>大家好！</p>
              <p>
                6月15日，<span class="color-red"
                  >“华为伙伴暨开发者大会2022”</span
                >
                将通过线上加线下的方式举行。在这次活动中，我们将围绕伙伴和开发者关心的一些热点话题，比如军团、商业市场、华为云以及计算产业的发展等等，与大家进行深入交流。我们还将推出新的产品和发布新的伙伴政策。
              </p>
              <p>您的参与和您的建议，是我们最大的期待。</p>
              <p>“因聚而生，为你所能”。</p>
              <p>6月15日，不见不散！</p>
              <!--              数字世界日新月异，直面数字化新蓝海，扬帆起航、乘风破浪，需要每一位合作伙伴与开发者的共同努力，以赢得先机。<br />-->
              <!--              <span class="color-red">首届“华为伙伴暨开发者大会”</span>，以<span-->
              <!--                class="title"-->
              <!--                >“因聚而生 为你所能”</span-->
              <!--              >为主题，采用线上直播+线下近90个分会场联动的形式，承接<span-->
              <!--                class="link_text cs"-->
              <!--                @click="didClick_link(0)"-->
              <!--                >“华为中国生态大会”</span-->
              <!--              >开放共赢的理念和<span-->
              <!--                class="link_text cs"-->
              <!--                @click="didClick_link(1)"-->
              <!--                >“HDC.Cloud”</span-->
              <!--              >勇于创新的精神，聚焦伙伴和开发者最为关切的话题，给出切实方案；聚合每一位ICT产业成员，能力互补，共同成就；释放更多潜力，拥抱更广阔的价值新空间，携手实现更大的商业成功。-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <DidLink :isHave="false"></DidLink>-->
    <video-player
      v-if="selectVideo"
      :propsData="{
        showImagesRealPath: [],
        url: this.$config.introduceVideo,
      }"
      @changeSelectVideo="changeSelectVideo"
    ></video-player>
  </div>
</template>

<script>
import Title from "./common/Title";
import { staticApi } from "../services";
import VideoPlayer from "@/components/common/VideoPlayer";
export default {
  name: "Introduce",
  data() {
    return {
      bgImg: require("../assets/images/introduce/live-bg.png"),
      pauseImg: require("../assets/images/introduce/pause-mobile.png"),
      titleBgImg: require("../assets/images/wap/title/introduce.png"),
      introduce: null,
      playState: false,
      selectVideo: false,
      controls: false,
    };
  },
  components: {
    Title,
    VideoPlayer,
  },
  mounted() {
    //this.getIntrodce();
  },
  methods: {
    //关闭播放器
    changeSelectVideo() {
      this.selectVideo = false;
    },
    //获取大会介绍
    getIntrodce() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/${this.$config.intoduceId}.json`
        )
        .then((res) => {
          if (res.result === 0) {
            const introduce = res.content;
            if (
              introduce.showImagesRealPath &&
              introduce.showImagesRealPath[0]
            ) {
              introduce.showImagesRealPath[0] =
                introduce.showImagesRealPath[0].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
            }
            if (
              introduce.showImagesRealPath &&
              introduce.showImagesRealPath[1]
            ) {
              introduce.showImagesRealPath[1] =
                introduce.showImagesRealPath[1].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
            } else {
              introduce.showImagesRealPath[1] = introduce.showImagesRealPath[0];
            }
            this.introduce = introduce;
            this.$nextTick(() => {
              if (this.$store.state.isMobile) {
                this.$refs.introduceVideoWAP.addEventListener(
                  "play",
                  this.handlePlay,
                  true
                );
                this.$refs.introduceVideoWAP.addEventListener(
                  "pause",
                  this.handlePause,
                  true
                );
                this.$refs.introduceVideoWAP.addEventListener(
                  "ended",
                  this.handleEnded,
                  true
                );
              } else {
                this.$refs.introduceVideoPC.addEventListener(
                  "play",
                  this.handlePlay,
                  true
                );
                this.$refs.introduceVideoPC.addEventListener(
                  "pause",
                  this.handlePause,
                  true
                );
                this.$refs.introduceVideoPC.addEventListener(
                  "ended",
                  this.handleEnded,
                  true
                );
              }
            });
          }
          this.$bus.$emit("ready", "Introduce");
        })
        .catch((err) => {
          console.error("获取失败", err);
        });
    },
    didClick_pauseImg() {
      this.selectVideo = true;
      //埋码
      window._hw("send", "action", "index_meeting_introduce_media_click");
      // console.log("点击播放");
      // console.log("暂停状态", this.$refs.introduceVideoPC.paused);
      // if (this.$store.state.isMobile) {
      //   if (this.$refs.introduceVideoWAP.paused) {
      //     this.$refs.introduceVideoWAP.play();
      //     this.playState = true;
      //     this.controls = true;
      //   } else {
      //     this.$refs.introduceVideoWAP.pause();
      //     this.playState = false;
      //     this.controls = false;
      //   }
      // } else {
      //   if (this.$refs.introduceVideoPC.paused) {
      //     this.$refs.introduceVideoPC.play();
      //     this.playState = true;
      //     this.controls = true;
      //   } else {
      //     //this.$refs.introduceVideoPC.pause();
      //     this.playState = false;
      //     this.controls = false;
      //   }
      // }
    },
    handlePlay() {
      if (this.$store.state.isMobile) {
        this.$refs.introduceVideoWAP.play();
      } else {
        //this.$refs.introduceVideoPC.play();
      }
      this.playState = true;
    },
    handlePause() {
      if (this.$store.state.isMobile) {
        this.$refs.introduceVideoWAP.pause();
      } else {
        //this.$refs.introduceVideoPC.pause();
      }
      this.controls = false;
      this.playState = false;
    },
    handleEnded() {
      if (this.$store.state.isMobile) {
        this.$refs.introduceVideoWAP.load();
      } else {
        //this.$refs.introduceVideoPC.load();
      }
    },
    //跳转 外链
    didClick_link(type) {
      if (type == 0) {
        //生态
        window.open(this.$config.partnerUrl);
      } else {
        //HDC
        window.open(this.$config.HDCUrl);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 隐藏video 音量按钮
video::-webkit-media-controls-mute-button {
  display: none !important;
}

// 隐藏video 全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}

video::-webkit-media-controls-enclosure {
  display: none;
}
#introduce-pc {
  display: none;
}

#introduce-wap {
  display: none;
}
.introduce-container {
  display: block;
  position: relative;
  z-index: $z-index-introduce;
}

@media screen and (max-width: 992px) {
  #introduce-wap {
    display: block;
    padding-top: 143px;
    padding-bottom: 0;
    .content-box {
      width: calc(100% - 70px);
      margin-left: 35px;
      padding: 45px 48px;
      background: url("../assets/images/introduce/live-border-wap.png");
      background-size: calc(100%) 949px;
      background-repeat: no-repeat;
      background-position: 0 0;
      .content {
        padding: 39px 0;
        font-size: 24px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        .title {
          width: 100%;
          font-size: 30px;
          font-family: Microsoft YaHei-Light;
          font-weight: 600;
          span {
            color: #b4251e;
          }
        }
        .con {
          text-align: justify;
          word-break: break-all;
          text-justify: distribute;
          //width: 600px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #151e26;
          line-height: 33px;
          p {
            margin-bottom: 12px;
          }
          .title {
            font-size: 26px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
          }
          .link_text {
            font-size: 24px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
          }
          .color-red {
            color: #b4251e;
            font-size: 26px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
          }
        }
      }
      .media {
        //margin-left: 35px;
        margin-top: 50px;
        width: 100%;
        position: relative;
        .bgImg {
          width: 582.51px;
          height: 327px;
          background: url("../assets/images/introduce/live-bg.png");
          background-size: 582.51px 327px;
        }

        .pauseImg {
          position: absolute;
          top: calc(50% - 54px);
          left: calc(50% - 54px);
          width: 108px;
          height: 108px;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  #introduce-pc {
    display: block;
    width: 100%;
    padding: 60px 160px 60px 160px;
    box-sizing: border-box;
    .content {
      width: 1600px;
      position: relative;
      display: flex;
      .text {
        background: url("../assets/images/introduce/left-border.png");
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 800px 406px;
        width: 800px;
        height: 406px;

        .title {
          width: 579px;
          height: 44px;
          margin-top: 67px;
          font-size: $font-xxl;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          line-height: 37px;
          span {
            color: #b4251e;
          }
        }

        .con {
          width: calc(100% - 70px);
          height: 100%;
          padding: 42px 10px 33px 60px;
          font-size: $font-xxl;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #151e26;
          line-height: 32px;
          text-align: justify;
          word-break: break-all;
          text-justify: distribute;
          p {
            margin-bottom: 8px;
          }
          .color-red {
            font-size: 20px;
            color: #b4251e;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
          }
          .title {
            font-size: 20px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
          }
          .link_text {
            font-size: 18px;

            font-family: Microsoft YaHei-Light;
            font-weight: 600;
          }
        }
      }

      .media {
        width: 800px;
        height: 406px;
        border-radius: 0 0 0 0;
        position: relative;
        //background: url("../assets/images/introduce/right-border.png");
        //background-repeat: no-repeat;
        //background-position: bottom right;
        //background-size: 745px 534px;

        .bgImg {
          margin-left: 17px;
          width: 713px;
          height: 401px;
          background: url("../assets/images/introduce/live-bg.png");
          background-size: 713px 401px;
          background-repeat: no-repeat;
          background-position: 0 0;
        }
        .pauseImg {
          width: 88px;
          flex-shrink: 0;
          position: absolute;
          cursor: pointer;
          top: calc(50% - 42px);
          left: calc(50% - 44px);
          z-index: 2;
        }
      }
    }
  }
}
</style>
